import React, { useEffect, useState } from 'react';
import {
    Navigate,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';

import Authorized from '../pages/Layouts/Authorized';
import NotAuthorized from '../pages/Layouts/NotAuthorized';
import { error_message } from '../components/Toast';

export const PrivateRoute = ({ children, allowedRoles }) => {
    const { user, userRoles, signOut } = useAuth();
    const [redirectTo, setRedirectTo] = useState('/');

    useEffect(() => {
        if (user) {
            const currentPath = window.location.pathname;
            const urlParams = window.location.search;
            const urlParamsObj = new URLSearchParams(urlParams);

            const companyID = urlParamsObj.get('companyID');
            const reportYearID = urlParamsObj.get('reportyearID');
            const selectedReportYear = urlParamsObj.get('selectedReportYear');

            if (companyID || reportYearID) {
                var userData = JSON.parse(localStorage.getItem('@QualityApp:user'));

                if (companyID != null) {
                    if (userData.companyID != null && userData.companyID != companyID) {
                        error_message("You are logged in, but the supplier in the link doesn't match. Please log out and log in again.");
                        signOut();
                    }
                }

                userData.selectedCompanyID = companyID;
                userData.selectedReportYearID = reportYearID;
                userData.selectedReportYear = selectedReportYear;
                localStorage.setItem('@QualityApp:user', JSON.stringify(userData));
                urlParamsObj.delete('companyID');
                urlParamsObj.delete('reportyearID');
                urlParamsObj.delete('selectedReportYear');

                const cleanUrl = `${currentPath}${urlParamsObj.toString() ? '?' + urlParamsObj.toString() : ''}`;
                window.history.replaceState({}, '', cleanUrl);

                localStorage.removeItem('@QualityApp:redirectAfterLogin');
                localStorage.removeItem('@QualityApp:companyID');
                localStorage.removeItem('@QualityApp:reportYearID');
                localStorage.removeItem("@QualityApp:selectedReportYear");
            }

            const savedRedirect = localStorage.getItem("@QualityApp:redirectAfterLogin");
            if (savedRedirect) {
                setRedirectTo(savedRedirect);
                
            } else {
                setRedirectTo('/');
            }
        }
    }, [user, userRoles, signOut]);

    if (user) {
        if (allowedRoles != null && !allowedRoles.some(role => userRoles?.includes(role))) {
            return <Navigate to="/" replace />;
        }
    }

    if (!user) {
        const currentPath = window.location.pathname;
        const urlParams = window.location.search;

        const urlParamsObj = new URLSearchParams(urlParams);
        const companyID = urlParamsObj.get('companyID');
        const reportYearID = urlParamsObj.get('reportyearID');
        const selectedReportYear = urlParamsObj.get('selectedReportYear');

        if (companyID && reportYearID) {
            localStorage.setItem("@QualityApp:redirectAfterLogin", currentPath);
            localStorage.setItem("@QualityApp:companyID", companyID);
            localStorage.setItem("@QualityApp:reportYearID", reportYearID);
            localStorage.setItem("@QualityApp:selectedReportYear", selectedReportYear);

        } else {
            //localStorage.setItem("@QualityApp:redirectAfterLogin", currentPath + urlParams);
        }
        return <Navigate to="/signin" replace />;
    }

    var roles = [];
    if (userRoles != null) {
        roles = userRoles.constructor === Array ? userRoles : JSON.parse(userRoles);
    }
    const Layout = user && roles.length > 0 ? Authorized : NotAuthorized;

    return (
        <Layout>
            {children}
        </Layout>
    );
};

export const PublicRoute = ({ children }) => {
    const { user, userRoles } = useAuth();

    var roles = [];
    if (userRoles != null) {
        roles = userRoles.constructor === Array ? userRoles : JSON.parse(userRoles);
    }
    const Layout = user && roles.length > 0 ? Authorized : NotAuthorized;

    return (
        <Layout>
            {children}
        </Layout>
    );
};
